function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-828.000000, -565.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(807.000000, 548.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.46428571,7 L4.55357143,9.46376812 L2.42857143,9.46376812 C1.08265714,9.46376812 0,10.5621159 0,11.9275362 L0,19.3188406 C0,20.6842609 1.08265714,21.7826087 2.42857143,21.7826087 L14.5714286,21.7826087 C15.9173429,21.7826087 17,20.6842609 17,19.3188406 L17,11.9275362 C17,10.5621159 15.9173429,9.46376812 14.5714286,9.46376812 L12.4464286,9.46376812 L11.5357143,7 L5.46428571,7 Z M8.5,12.173913 C10.3366652,12.173913 11.826087,13.6633348 11.826087,15.5 C11.826087,17.3366652 10.3366652,18.826087 8.5,18.826087 C6.66333478,18.826087 5.17391304,17.3366652 5.17391304,15.5 C5.17391304,13.6633348 6.66333478,12.173913 8.5,12.173913 Z"
}))))));

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.30a13f21.svg";
export { ForwardRef as ReactComponent };